import type { RequiredEventForm } from '../types';

/**
 * Parses a Form.io form schema JSON string into a form definition object.
 * Ensures display: 'form', type: 'form', and components array for Formio renderer.
 */
export function parseFormSchema(formSchema: string): Record<string, unknown> | null {
  try {
    const parsed = JSON.parse(formSchema) as unknown;
    if (!parsed || typeof parsed !== 'object') return null;
    const obj = parsed as Record<string, unknown>;
    if (Array.isArray(obj.components)) {
      return { display: 'form', type: 'form', components: obj.components, ...obj };
    }
    return obj as Record<string, unknown>;
  } catch {
    return null;
  }
}

/**
 * Unique key per required-form row (same template can appear for multiple events/children).
 */
export function getFormRowKey(form: RequiredEventForm): string {
  return `${form.id}-${form.eventUuid ?? ''}-${form.childName ?? ''}-${form.eventName ?? ''}`;
}
